
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.7 7.8C6.3 9.4 6 12.1 6 24.2 6 43 5 42 24.2 42 43 42 42 43 42 23.8 42 5 43 6 23.8 6 11 6 9.1 6.2 7.7 7.8zM38.5 24v14.5h-29l-.3-13.4c-.1-7.4 0-14.1.2-14.8.4-1.1 3.7-1.3 14.8-1.1l14.3.3V24z"}}),_c('path',{attrs:{"d":"M24.1 17.2c-.4 1.3-1.4 5.1-2.1 8.6-1.2 6.1-.9 8.5.9 6.6 1-.9 4.1-13.3 4.1-16 0-2.2-2-1.7-2.9.8zM14.2 21l-2.3 3 2.3 3c2.2 3 4.8 4 4.8 1.8 0-.6-.7-2-1.7-3-1.5-1.7-1.5-1.9 0-3.6 1-1 1.7-2.4 1.7-3 0-2.2-2.6-1.2-4.8 1.8zM29 19.2c0 .6.7 2 1.7 3 1.5 1.7 1.5 1.9 0 3.6-1 1-1.7 2.4-1.7 3 0 2.2 2.6 1.2 4.8-1.8l2.3-3-2.3-3c-2.2-3-4.8-4-4.8-1.8z"}})])
          )
        }
      }
    